<template>
	<Form ref="formValidate" :model="formValidate" :label-width="110" :label-colon="true">
		<Row>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="状态" :label-width="80">
				<Select v-model="formValidate.checkStatus" clearable  style="width:200px">
					<Option :value="0" key="0">待支付</Option>
					<Option :value="1" key="1">待发布</Option>
					<Option :value="2" key="2">待审核</Option>
					<Option :value="3" key="3">审核失败</Option>
					<Option :value="4" key="4">审核通过</Option>
					<Option :value="5" key="5">已下线</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="场景"   :label-width="80">
				<Select v-model="formValidate.scene" clearable style="width:200px">
					<Option :value="1" key="1">线上</Option>
					<Option :value="2" key="2">线下</Option>
					<Option :value="3" key="3">不限</Option>
				</Select>
			</FormItem>
			</Col>
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="用户名" :label-width="100">
				<Input v-model="formValidate.userName" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="用户id" :label-width="100">
				<Input v-model="formValidate.userId" clearable />
			</FormItem>
			</Col>
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="企业名称" :label-width="80">
				<Input v-model="formValidate.company" clearable />
			</FormItem>
			</Col>
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="岗位名称" :label-width="80">
				<Input v-model="formValidate.title" clearable />
			</FormItem>
			</Col>
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="岗位id" :label-width="80">
				<Input v-model="formValidate.jobId" clearable />
			</FormItem>
			</Col>
			<Col :md="12" :sm="12" :xs="24">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 0px;">查询</Button>
				<Button type="default" @click="formReset" style="margin: 0 8px 16px 16px;">重置</Button>
			</FormItem>
			</Col>
		</Row>
	</Form>

</template>
<script>
	import api from '../../api'
	import {
		mapGetters
	} from 'vuex'
	import {
		STATISTICS_START_TIME,
		LINK_TYPES
	} from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {

		},
		data() {
			return {
				apps: [],
				events: [],
				appId: '',
				advertType: 'table',
				formValidate: {
					checkStatus: undefined,
					scene: undefined,
					userName:undefined,
					userId:undefined,
					company: '',
					jobId: undefined,
					title: '',
				}
			}
		},
		computed: {
			...mapGetters('statistics', ['accountGroup', 'pageStatus'])
		},
		mounted() {

		},
		methods: {
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {
					checkStatus: undefined,
					scene: undefined,
					userName:undefined,
					userId:undefined,
					company: '',
					jobId: undefined,
					title: '',
				}
				//this.formSubmit()
			},
			getFormData() {
				const formData = {
					checkStatus: this.formValidate.checkStatus,
					scene: this.formValidate.scene,
					userName:this.formValidate.userName,
					userId:this.formValidate.userId,
					company: this.formValidate.company,
					jobId: this.formValidate.jobId,
					title: this.formValidate.title,
				}
				return formData
			},

		}
	}
</script>